import ProximityAd from 'components/Ad/ProximityAd';
import { screen } from 'components/styles/variables';
import { HALF_PAGE_SKYSCRAPER, MEDIUM_RECTANGLE } from 'lib/GoogleAds/Sizes';
import css from 'styled-jsx/css';
import classNames from 'classnames';

/* istanbul ignore next */
const { styles, className } = css.resolve`
  .sidebar-ad {
    margin-bottom: 20px;
  }
`;
const stickyCss = css.resolve`
  position: sticky;
  top: 0;
`;

export default function SidebarAds({ sticky = true }: { sticky?: boolean }): JSX.Element {
  return (
    <div className="sidebar-ads">
      <ProximityAd
        adConfig={{
          targeting: { slot: 'dt-box-1' },
          dimensions: [
            [300, 250],
            [300, 600],
          ],
        }}
        placeholderSize={HALF_PAGE_SKYSCRAPER}
        className={`sidebar-ad ${className}`}
      />
      <ProximityAd
        placeholderSize={MEDIUM_RECTANGLE}
        adConfig={{
          targeting: { slot: 'dt-box-2' },
          dimensions: [[300, 250]],
        }}
        className={`sidebar-ad ${className}`}
      />
      <ProximityAd
        className={classNames({
          [stickyCss.className]: sticky,
        })}
        placeholderSize={MEDIUM_RECTANGLE}
        adConfig={{
          targeting: { slot: 'dt-box-breaker' },
          dimensions: [
            [300, 250],
            [300, 600],
          ],
        }}
      />
      <style jsx>{`
        .sidebar-ads {
          display: none;
        }

        @media (min-width: ${screen.lgMin}) {
          .sidebar-ads {
            display: block;
            width: 300px;
            flex-shrink: 0;
          }
        }
      `}</style>
      {styles}
      {stickyCss.styles}
    </div>
  );
}
